define('views/modules/profile/list/custom-messages-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'bootbox', 'utils',
    // services
    'services/i18n',

    'views/parts/media-info-box',
    // templates
    'text!templates/modules/setting/personal/blocks/custom-messages/list/custom-messages-list-item.html'

], function(
    // Libs
    _, Backbone, Mustache, moment, Bootbox, U,
    // services
    i18n,
    // views
    VMediaInfoBox,
    // templates
    TCustomMessageListItem
) {

    var VCustomMessagesListItem = Backbone.View.extend({
        //className: 'custom-messages-list-item',
        template: TCustomMessageListItem,

        regions: {
            infobox: ".item-section",
        },
        initialize: function(opt) {
            this.options = opt || {};

            _.extend(this, {
                // profile: opt.profile,
                // group: opt.group
            });

            var model = this.model,
                view = this.view = {
                    infobox: new VMediaInfoBox({
                        title: 'title',
                        subtitle: 'defaultWelcomeMessageSubtitle',
                        model: this.model,
                        context: this,
                        onClick: this.onCustomMessageClick,
                        menu: {
                            init: this.onMenuInit,
                            onClick: this.onActionClick,
                        }
                    }),
                };

            // this.setUrl('assign', Mustache.render('#/supervisor/group/{{{groupId}}}/member/{{{userId}}}/calendar/{{dayId}}/template/assign/', {
            //     groupId: this.group.id,
            //     userId: this.profile.id,
            //     dayId: moment().format('YYYY-MM-DD')
            // }));

            this.listenTo(model, { 'remove': this.remove });
        },
        render: function() {
            //this.assign(this.view.infobox, this.$el);

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            // this.view.infobox.subtitle = this.view.infobox.subtitle.replace(/(?:\r\n|\r|\n)/g, '<br />');
            // U.log(this.view.infobox);

            // this.view.infobox.model.attributes.message = this.view.infobox.model.attributes.message.replace(/(?:\r\n|\r|\n)/g, '<br />');

            this.generateZones()
                .assign(this.view.infobox, this.regions.infobox);

            return this;
        },

        deleteCustomMessage: function(result) {
            if (result) this.model.destroy({ wait: true });
        },

        /*
                setActive: function(val) {
                    this.$el.toggleClass('active', val);

                },

                isActive: function() {
                    return this.$el.hasClass('active');
                },
        */
        ////////////
        // events //
        ////////////
        onCustomMessageClick: function(e) {
            this.model.trigger('customMessage:click', this.model);
        },

        onMenuInit: function() {
            return new Backbone.Collection([
                { caption: 'Delete', icon: "sl-icon-trash", callback: this.onDeleteAction }
            ]);
        },

        onActionClick: function(e, item) {
            //if (!item.has('route'))
            e.preventDefault();
        },

        onDeleteAction: function() {
            Bootbox.confirm({
                title: i18n.t("Delete template"),
                message: i18n.t("messages:message-delete-template"),
                onEscape: true,
                backdrop: true,
                callback: this.deleteCustomMessage,
                context: this,
            });
        },

    });

    return VCustomMessagesListItem;

});

